import api, { Base } from 'ev-api/api';

import type {
  CensusPatient,
  DetailFieldConfig,
  EDataMapping,
  FieldConfig,
  GetPatientCensusParams,
  GetPatientCensusResponse,
} from './params';

export type PatientCensusData = {
  patients: CensusPatient[];
  listItemFields: FieldConfig[];
  detailsFields: DetailFieldConfig[];
  eDataMapping?: EDataMapping;
};

const cdxPatientCensusApi = api.injectEndpoints({
  endpoints: builder => ({
    getPatientCensus: builder.query<PatientCensusData, GetPatientCensusParams>({
      query: ({ practiceId, visitTypeId }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'patient_census',
          event: 'census_query',
          correlation_id: crypto.randomUUID(),
          practice_id: practiceId,
          search_query: '',
          visit_type_id: visitTypeId,
        },
      }),
      transformResponse: (response: GetPatientCensusResponse) => {
        if (!response.data) {
          return {
            patients: [],
            listItemFields: [],
            detailsFields: [],
          };
        }

        const patients = response.data.queryResult[0] || [];

        return {
          patients,
          listItemFields: response.data.listItemFields,
          detailsFields: response.data.detailsFields,
          eDataMapping: response.data.eDataMapping,
        };
      },
    }),
  }),
});

export const { useGetPatientCensusQuery, useLazyGetPatientCensusQuery } =
  cdxPatientCensusApi;
